export default __webpack_public_path__ + "static/media/6.f9a10072.png";